import { AttendanceHistoryTable as _AttendanceHistoryTable } from './model';
import create from './create';

const AttendanceHistory = _AttendanceHistoryTable;

AttendanceHistory.create = create;

export default AttendanceHistory;



// WEBPACK FOOTER //
// ./data/AttendanceHistory/model/index.js